import {Component} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {ProductService} from '../../services/product.service';
import {Category, Comparison, Product} from '../../models';
import {ComparisonService} from '../../services/comparison.service';
import {forkJoin} from 'rxjs';
import {CategoryService} from '../../services/category.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})

export class ProductComponent {
  public language = 'en';
  public product: Product;
  public categories: Category[] = Array();
  public comparableProducts: Product[] = Array();
  public comparison: Comparison;
  public displayedColumns: string[] = ['name', 'product', 'comp_one'];


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private productService: ProductService,
    private categoryService: CategoryService,
    private comparisonService: ComparisonService,
  ) {
    // @ts-ignore
    router.events.subscribe( (event: Event) => {
      if (event instanceof NavigationEnd) {
        this.loadPage();
      }
    });
  }

  public loadPage() {
    this.route.url.subscribe(url => {
      this.language = url[0].path;
      const prodID = url[2].path;
      forkJoin(
        this.productService.get(prodID, {lang: this.language}),
        this.categoryService.list({lang: this.language})
      ).subscribe(([product, categories]) => {
        this.categories = categories;
        this.product = product;
        if (this.product.has_comparison) {
          this.comparisonService.get(prodID, {lang: this.language}).subscribe(comparison => {
            this.comparison = comparison;
            if (this.comparison.two_name) {
              this.displayedColumns = ['name', 'product', 'comp_one', 'comp_two'];
            }
          });
        }
      });
    });
  }
}
